import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-25105fe1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "log"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAANlBMVEX///////////////////////////9HcEz////////////////////////////////////////xvgS0AAAAEnRSTlP/nUkTHSnaAO17BIhusTzGUaX0nW8dAAABKElEQVQ4y5WU65bFEAyF45YQVe37v+yEg/Ys047Jr730a7A3gEbZgH7/yN1jsNcX6MIokEJTNRatzASdMuwBUtGpSjgnSBppzgAb0QaQWUurCQoAlqw0CKK8SFETdEgnIg21PuqYIFdnoliYSHVON0Hc1uCk2hr5gsypwuE4tp31kh0GdkdQpxFIQavuZPezjysCOxhHX+UGZUE2rK3eVNq/GeI9qU0+ybSA4Jlein1BxF77zNhcItolTK/HoIk5x5EsaemBu1iQmn1X/tipYm0y1Uwxt7sro4jjH0mhxgAj3FoZkBkhtwW1kDvkfoPcDVqYbmXhSxYsmflXLFSQx4DpFvDTUeH7UVk6dC/HN17Hd+ki/OdKLV3OpWu+9GAsPT1Lj9jbc/gDM4IdSGBDRg0AAAAASUVORK5CYII=",
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "userinfo"
};
const _hoisted_5 = {
  class: "head"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "info"
};
const _hoisted_8 = {
  class: "name"
};
const _hoisted_9 = {
  class: "username"
};
const _hoisted_10 = {
  class: "cid"
};
const _hoisted_11 = {
  style: {
    "padding-left": "40px"
  }
};
const _hoisted_12 = {
  key: 1,
  class: "info"
};
const _hoisted_13 = {
  class: "name"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "username"
}, "欢迎加入快乐8", -1));
const _hoisted_15 = {
  key: 2,
  href: "/signin"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "signin"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAztJREFUSEvFll+IlGUUxn/P941syCJ7oSLUTcWKrJp/aHNHopsuMvXCSBHWUi+8yhttHUNQGigQ2V1aUusmsD+yYCZ4o5FQiODO6haoUS5lQVAQtLlbLJtTM++J9/tmxpndmWl3dslz+Z1znuec851z3iPqSapjO+gj4DqON+jNfFbVvCv5HAFHgKfAXqZ78EwtWJUU27aFLBlPVBg+NHYU2A/2M6Y3yba8XxWoaWw3ssOgR4C3uNdyqMLu1+YcZ8/m/TexP/kwCbZg1oxorgTUs0ASsz+RroDdqB65VmP2DNICIAP2eYWdMY40To7zIpU8CrYHmA+aX7fEDSttApgAvSdSHb+BFoJNYHwNfI/kYmxbDXoi0qGbka66tIKtigO2W6C4EmYB0IpYWdCN+AytAD6C0Y/pIrKo3ohdoJfARhAf4vi0Kl/A8xg7C4GfxvggJlSIbCOiM9Z5yCKh8QlhLs2xoW9KoAfWb0LWg7hGXifpHRiq3qXr2wltL8Y6TAfoGbhQsnutfTn5RBqxdTJhP3Jpuq9NLZvvYC+FTptCWk+fWteKBZ6wc/qEDTcLUJMQO4fRTTb742zwp/g2NT3mfxzoxcoMZd9hDIHG5pQQa0G0Y1paSTi3LDXRysbi/2G8Tygu4KwPC2oNd2MRybUSaB/GpgfcpX7L1JrDern5tnfyuxgUXKkYev9txnPYFW2RBVjud+6N3ub4neykLfI0Ygdmv4Cu0pM5URHfjAkPJv0buATjLs6dIpG7zrGv/sCvLBceAbUhHsVxDuwiPYMfz44w1fEuaC2iDeMyZoNYcInAdYG2Iv6Kvjv3dimYcsYZZxidGbwQgWOjoBGk45j1AfOil8ToI/znRJT5ZJkxoQe4Xz6/8eNFHsswZqdrkjXUNEXouHleL85TROa0gUR2rGpmRb+GMiw6x5muADbjgsP0Dvz0n9ugzmtxBqc0vZnhmiCH1izCJRaTTywl/PuLupmVKpNcRmBpkO+FshcfvsTcO1iQIXDxiTFbcUGIXBIFrwBPFgjLjij0LdgPmOaGUBaCHgdrKz+ibgPLZpvMNP2HxavJNYT0gy0sXlbTdJ6uWR7hZ3WUPJ3/AtsCnzsdV1XUAAAAAElFTkSuQmCC",
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", null, "签到 ")], -1));
const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  class: "road"
};
const _hoisted_19 = {
  class: "title"
};
const _hoisted_20 = {
  class: "nav_list"
};
const _hoisted_21 = ["onClick"];
import nav_header from '@/components/nav_header.vue';
import msgs from '@/components/prompt.vue';

import { reactive, ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    let userInfo = reactive({
      avatar: require('../../assets/image/logo.jpeg'),
      nickname: '未登陆',
      id: '0',
      username: '未登陆'
    });
    let msg = ref('账号不能为空');
    let show = ref(false);
    let showss = ref(false);
    let listArray = ref([{
      title: '必备工具',
      list: [{
        name: '我的优惠',
        path: '',
        style: 'me_roods_imgs_12'
      }, {
        name: '邀请好友',
        path: '',
        style: 'me_roods_imgs_13'
      }, {
        name: '在线客服',
        path: '//',
        style: 'me_roods_imgs_14'
      }, {
        name: '接口调用',
        path: '/api',
        style: 'me_roods_imgs_15'
      }]
    }, {
      title: '我的频道',
      list: [{
        name: '我的关注',
        path: '/cares',
        style: 'me_roods_imgs_0'
      }, {
        name: '我的收藏',
        path: '/collect',
        style: 'me_roods_imgs_1'
      },
      // {name:'我的点赞',path:'/like',style:'me_roods_imgs_2'},
      // {name:'竞猜记录',path:'',style:'me_roods_imgs_3'},
      {
        name: '我的评论',
        path: '/comment',
        style: 'me_roods_imgs_4'
      }, {
        name: '我的发布',
        path: '/publish',
        style: 'me_roods_imgs_5'
      }
      // {name:'小黑屋',path:'/banList',style:'me_roods_imgs_6'},
      // {name:'报码开',path:'',style:'me_roods_imgs_7'},
      ]
    }, {
      title: '排行榜',
      list: [{
        name: '等级排行榜',
        path: '',
        style: 'me_roods_imgs_8'
      }, {
        name: '粉丝排行榜',
        path: '',
        style: 'me_roods_imgs_9'
      }, {
        name: '分享排行榜',
        path: '',
        style: 'me_roods_imgs_10'
      }, {
        name: '敬请期待',
        path: '',
        style: 'me_roods_imgs_11'
      }]
    }, {
      title: '平台信息',
      list: [{
        name: '站内消息',
        path: '/stationNews',
        style: 'me_roods_imgs_16'
      }, {
        name: '意见反馈',
        path: '/feedback',
        style: 'me_roods_imgs_17'
      }, {
        name: '关于我们',
        path: '/about',
        style: 'me_roods_imgs_18'
      }, {
        name: '下载APP',
        path: '',
        style: 'me_roods_imgs_19'
      }]
    }]);
    let public_conf = ref();
    const router = useRouter();
    onBeforeMount(() => {
      if (JSON.parse(localStorage.getItem('userInfo')) == null) {} else {
        userInfo = JSON.parse(localStorage.getItem('userInfo'));
      }
      public_conf.value = JSON.parse(localStorage.getItem('public_conf'));
    });
    let navTab = path => {
      if (path == '') {
        msg.value = '敬请期待';
        show.value = true;
        let timeout = setTimeout(() => {
          show.value = false;
          clearTimeout(timeout);
        }, 1000);
      } else if (path == '//') {
        window.location.href = public_conf.value[0].value;
      } else {
        if (JSON.parse(localStorage.getItem('userInfo')) == null) {
          showss.value = true;
        } else {
          router.push(path);
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_logos = _resolveComponent("logos");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "我的",
        iconleft: false
      }, {
        more: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_unref(userInfo).id != 0 ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/setup"
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        src: _unref(userInfo).avatar,
        alt: ""
      }, null, 8, _hoisted_6)]), _unref(userInfo).id != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_unref(userInfo).nickname), 1), _createElementVNode("div", _hoisted_9, "用户名: " + _toDisplayString(_unref(userInfo).mobile), 1), _createElementVNode("div", _hoisted_10, [_createTextVNode("ID号: " + _toDisplayString(_unref(userInfo).id) + " ", 1), _createElementVNode("span", _hoisted_11, "积分:" + _toDisplayString(_unref(userInfo).coin), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_router_link, {
        to: "/login"
      }, {
        default: _withCtx(() => [_createTextVNode(" 点击登陆图库")]),
        _: 1
      })]), _hoisted_14])), _unref(userInfo).id != 0 ? (_openBlock(), _createElementBlock("a", _hoisted_15, _hoisted_17)) : _createCommentVNode("", true)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listArray), (t, i) => {
        return _openBlock(), _createElementBlock("div", {
          class: "me-road",
          key: i
        }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(t.title), 1), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.list, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: $event => _unref(navTab)(item.path)
          }, [_createElementVNode("div", {
            class: _normalizeClass('icon ' + item.style)
          }, null, 2), _createElementVNode("p", null, _toDisplayString(item.name), 1)], 8, _hoisted_21);
        }), 128))])])]);
      }), 128)), _createVNode(msgs, {
        msg: _unref(msg),
        hidden: _unref(show)
      }, null, 8, ["msg", "hidden"]), _createVNode(_component_logos, {
        shows: _unref(showss),
        "onUpdate:shows": _cache[0] || (_cache[0] = $event => _isRef(showss) ? showss.value = $event : showss = $event)
      }, null, 8, ["shows"])], 64);
    };
  }
};